import type { Provider } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { i18nLoader } from './i18n-loader';

export function provideTranslocoScopeFactoryView(): Provider {
  return provideTranslocoScope({
    scope: 'shared-factory-view',
    alias: 'factoryView',
    loader: i18nLoader,
  });
}
